export const ROLE_CONSULTANT = 'Consultant';
export const ROLE_DTC_MANAGERS = 'DTC manager';
export const ROLE_BTL_SUPERVISORS = 'BTL supervisor';
export const ROLE_BTL_MANAGERS = 'BTL manager';
export const ROLE_ADMIN = 'Super Admin';
